export default {
  CLEAR: 'namesAndNumbers/CLEAR',
  CREATE: 'namesAndNumbers/CREATE',
  BATCH_CREATE: 'namesAndNumbers/BATCH_CREATE',
  REMOVE_EMPTY_NAMES_AND_NUMBERS:
    'namesAndNumbers/REMOVE_EMPTY_NAMES_AND_NUMBERS',
  REMOVE_INVALID_NAMES_AND_NUMBERS:
    'namesAndNumbers/REMOVE_INVALID_NAMES_AND_NUMBERS',
  UPDATE: 'namesAndNumbers/UPDATE',
  DELETE: 'namesAndNumbers/DELETE',
  ADD_NAMES: 'namesAndNumbers/ADD_NAMES',
  ADD_NUMBERS: 'namesAndNumbers/ADD_NUMBERS',
  ADD_NAMES_AND_NUMBERS: 'namesAndNumbers/ADD_NAMES_AND_NUMBERS'
};
